import React, { Fragment, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link, NavLink } from "react-router-dom";

const menus = [
  {
    id: 1,
    title: "Money Transfer",
    link: "/moneytransfer",
  },
  {
    id: 3,
    title: "About Us",
    link: "/about",
  },
  {
    id: 5,
    title: "Help",
    link: "/help",
  },

  {
    id: 88,
    title: "Contact Us",
    link: "/contact",
  },
];

const MobileMenu = () => {
  const [openId, setOpenId] = useState(0);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <ul className="xb-menu-primary clearfix">
      {menus.map((item, mn) => {
        return (
          <ListItem className={item.id === openId ? "active" : null} key={mn}>
            {item.submenu ? (
              <Fragment>
                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                  {item.title}
                  <i
                    className={
                      item.id === openId ? "fa fa-angle-up" : "fa fa-angle-down"
                    }
                  ></i>
                </p>
                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                  <List className="menu-item menu-item-has-children active">
                    <Fragment>
                      {item.submenu.map((submenu, i) => {
                        return (
                          <ListItem key={i}>
                            <Link
                              onClick={ClickHandler}
                              className="active"
                              to={submenu.link}
                            >
                              {submenu.title}
                            </Link>
                          </ListItem>
                        );
                      })}
                    </Fragment>
                  </List>
                </Collapse>
              </Fragment>
            ) : (
              <Link className="active" to={item.link}>
                {item.title}
              </Link>
            )}
          </ListItem>
        );
      })}

      <div
        className="xb-btn"
        style={{
          display: "block",
          "@media (max-width: 768px)": { display: "block" }, // This will NOT work inline. Inline CSS does not support media queries.
        }}
      >
        <a
          onClick={ClickHandler}
          href="https://bugamoney.co.uk/app/sign-up"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            padding: "6px 18px",
            fontSize: "14px",
            borderRadius: "10px",
            backgroundColor: "#000",
            color: "#fff",
            textDecoration: "none",
            display: "inline-block",
          }}
        >
          Signup
        </a>

        <a
          onClick={ClickHandler}
          href="https://bugamoney.co.uk/app/app-login"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            padding: "6px 18px",
            fontSize: "14px",
            borderRadius: "10px",
            backgroundColor: "#ffac07",
            color: "#000",
            textDecoration: "none",
            display: "inline-block",
            marginLeft: "8px",
          }}
        >
          Login
        </a>
      </div>
    </ul>
  );
};

export default MobileMenu;
